import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login')
  },
  {
    path: '/',
    redirect: '/detail'
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/detail',
    meta: {
      title: ''
    },
    component: () => import('@/views/home/index')
  },
  {
    path: '/detail',
    name: 'detail',
    meta: {
      title: ''
    },
    component: () => import('@/views/details/index')
  },
  {
    path: '/formFillIn',
    name: 'formFillIn',
    meta: {
      title: ''
    },
    component: () => import('@/views/form-fill-in/index')
  },
  {
    path: '/preview',
    name: 'preview',
    meta: {
      title: ''
    },
    component: () => import('@/views/filePreview/index')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router
